<template>
  <main id="main" class="background-wrapper">
    <div class="topslider wave">
      <div class="mv-slider">
        <div class="container">
          <div class="textholder">
            <div class="mv-slider__small">
              <div class="textdate harumi-font">
                <div class="textdate__left">
                  <p class="textdate__year">{{ curentYear }}</p>
                  <p class="textdate__weekday">{{ currentDay }}</p>
                </div>
                <div class="textdate__right">
                  <p class="textdate__monthday" v-if="currentDate < 10">{{(currentMonth + 1) + '.' + '0' + currentDate}}</p>
                  <p class="textdate__monthday" v-if="currentDate >= 10">{{(currentMonth + 1) + '.' + currentDate}}</p>
                </div>
              </div>
              <div class="mv-slider__small__item">
                <SliderSmall :sliderSmallChild="item" v-for="item in listSliderSmall" :key="item.id" />
              </div>
            </div>

            <div class="mv-slider__big">
              <div class="mv-slider__big__holder">
                <div v-if="bigSliderList.length > 0" class="mv-slider__big__item">
                  <SliderBig :isLoadingChild="isLoading" :sliderBigChild="item" :indexChild="index" v-for="(item, index) in bigSliderList" :key="index"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </div>

    <div class="topinfor" :style="[inforNewsList.length === 0 && eventList.length != 0 || shopGuideList.length === 0 ? {'padding-bottom': '0'} : {'padding-bottom': '72px'}]">
      <InfomationNewsList :infoNewsChild="inforNewsList"/>
    </div>

    <div class="topevent wave" :style="shopGuideList.length  === 0 ? {'margin-bottom': '30px'} : {'margin-bottom': '0'}">
      <div class="container wow fadeInUp" v-if="eventList.length != 0">
        <h2>EVENT<span>イベント</span></h2>
        <div class="topevent__list">
          <ItemEvent :isLoadingChild="isLoading" :itemEventChild="item" :index="index" v-for="(item, index) in eventList" :key="index"/>
        </div>
        <div class="topevent__link">
          <router-link class="btn_link" to="/event">もっと見る</router-link>
        </div>
      </div>
      <div class="container wow fadeInUp" v-else>
        <h2>EVENT<span>イベント</span></h2>
        <div class="no-data">
          <div class="text-notification">現在、ご案内する情報はありません</div>
        </div>
      </div>
    </div>

    <div class="topmyfavoritethings">
      <div class="container wow fadeInUp">
        <h2>MY FAVORITE THINGS<span>私のお気に入り</span></h2>
        <div class="topmyfavoritethings__holder">
          <div class="topmyfavoritethings__title">
            <h3>
              <span>テーマ</span>
              『HARUMI FLAGの〇〇』
              <svg viewBox="0 0 461 7">
                <path class="cls-1" d="M1.5,1.5c5.32,0,5.32,4,10.65,4S17.47,1.5,22.8,1.5c5.32,0,5.32,4,10.65,4,5.32,0,5.32-4,10.65-4,5.32,0,5.32,4,10.65,4,5.32,0,5.32-4,10.65-4,5.32,0,5.32,4,10.65,4,5.32,0,5.32-4,10.65-4,5.33,0,5.33,4,10.65,4s5.32-4,10.65-4c5.32,0,5.32,4,10.65,4,5.33,0,5.33-4,10.65-4,5.32,0,5.32,4,10.65,4,5.33,0,5.33-4,10.65-4,5.32,0,5.32,4,10.65,4,5.33,0,5.33-4,10.65-4,5.32,0,5.32,4,10.65,4,5.33,0,5.33-4,10.65-4,5.33,0,5.33,4,10.65,4s5.33-4,10.65-4c5.33,0,5.33,4,10.65,4,5.33,0,5.33-4,10.65-4,5.33,0,5.33,4,10.65,4,5.32,0,5.32-4,10.65-4,5.32,0,5.32,4,10.65,4,5.32,0,5.32-4,10.65-4,5.33,0,5.33,4,10.65,4,5.32,0,5.32-4,10.65-4,5.33,0,5.33,4,10.65,4s5.33-4,10.65-4,5.33,4,10.65,4c5.33,0,5.33-4,10.65-4,5.33,0,5.33,4,10.65,4,5.33,0,5.33-4,10.65-4,5.33,0,5.33,4,10.65,4,5.33,0,5.33-4,10.65-4,5.33,0,5.33,4,10.65,4,5.33,0,5.33-4,10.65-4,5.33,0,5.33,4,10.65,4,5.33,0,5.33-4,10.66-4,5.33,0,5.33,4,10.65,4,5.33,0,5.33-4,10.66-4,5.33,0,5.33,4,10.66,4"/>
              </svg>
            </h3>
          </div>
          <div class="topmyfavoritethings__decs">
            <ul>
              <li>
                <svg viewBox="0 0 19.38 24">
                  <path d="M15.8,9.81c-.17,0-.31.14-.35.32l-.8,3.81c-.03.18.07.32.24.32h2.71c.17,0,.28.11.24.28l-.52,2.58c-.04.18-.21.28-.38.28h-2.71c-.14,0-.31.14-.35.32l-1.21,6c-.03.18-.21.28-.38.28h-3.02c-.17,0-.28-.11-.24-.28l1.21-6c.03-.18-.07-.32-.24-.32h-2.85c-.14,0-.31.14-.35.32l-1.25,6c-.03.18-.17.28-.35.28h-3.06c-.17,0-.28-.11-.24-.28l1.25-6c.03-.18-.07-.32-.24-.32H.25c-.17,0-.28-.11-.24-.28l.52-2.58c.03-.18.21-.28.35-.28h2.71c.14,0,.31-.14.35-.32l.8-3.81c.03-.18-.07-.32-.24-.32H1.78c-.14,0-.28-.11-.24-.28l.56-2.58c0-.18.17-.28.35-.28h2.71c.17,0,.31-.14.35-.32L6.74.28c.03-.14.21-.28.38-.28h3.02c.17,0,.28.14.24.28l-1.25,6.07c-.03.18.07.32.24.32h2.81c.17,0,.35-.14.38-.32L13.79.28c.03-.14.21-.28.38-.28h3.02c.17,0,.28.14.24.28l-1.21,6.07c-.04.18.07.32.24.32h2.67c.17,0,.28.11.24.28l-.52,2.58c-.03.18-.21.28-.35.28h-2.71ZM8.72,9.81c-.14,0-.31.14-.35.32l-.8,3.81c-.03.18.07.32.24.32h2.85c.14,0,.31-.14.35-.32l.76-3.81c.03-.18-.07-.32-.21-.32h-2.85Z"/>
                </svg>
                <span>イベント</span>
              </li>
              <li>
                <svg viewBox="0 0 19.38 24">
                  <path d="M15.8,9.81c-.17,0-.31.14-.35.32l-.8,3.81c-.03.18.07.32.24.32h2.71c.17,0,.28.11.24.28l-.52,2.58c-.04.18-.21.28-.38.28h-2.71c-.14,0-.31.14-.35.32l-1.21,6c-.03.18-.21.28-.38.28h-3.02c-.17,0-.28-.11-.24-.28l1.21-6c.03-.18-.07-.32-.24-.32h-2.85c-.14,0-.31.14-.35.32l-1.25,6c-.03.18-.17.28-.35.28h-3.06c-.17,0-.28-.11-.24-.28l1.25-6c.03-.18-.07-.32-.24-.32H.25c-.17,0-.28-.11-.24-.28l.52-2.58c.03-.18.21-.28.35-.28h2.71c.14,0,.31-.14.35-.32l.8-3.81c.03-.18-.07-.32-.24-.32H1.78c-.14,0-.28-.11-.24-.28l.56-2.58c0-.18.17-.28.35-.28h2.71c.17,0,.31-.14.35-.32L6.74.28c.03-.14.21-.28.38-.28h3.02c.17,0,.28.14.24.28l-1.25,6.07c-.03.18.07.32.24.32h2.81c.17,0,.35-.14.38-.32L13.79.28c.03-.14.21-.28.38-.28h3.02c.17,0,.28.14.24.28l-1.21,6.07c-.04.18.07.32.24.32h2.67c.17,0,.28.11.24.28l-.52,2.58c-.03.18-.21.28-.35.28h-2.71ZM8.72,9.81c-.14,0-.31.14-.35.32l-.8,3.81c-.03.18.07.32.24.32h2.85c.14,0,.31-.14.35-.32l.76-3.81c.03-.18-.07-.32-.21-.32h-2.85Z"/>
                </svg>
                <span>暮らし自慢</span>
              </li>
              <li>
                <svg viewBox="0 0 19.38 24">
                  <path d="M15.8,9.81c-.17,0-.31.14-.35.32l-.8,3.81c-.03.18.07.32.24.32h2.71c.17,0,.28.11.24.28l-.52,2.58c-.04.18-.21.28-.38.28h-2.71c-.14,0-.31.14-.35.32l-1.21,6c-.03.18-.21.28-.38.28h-3.02c-.17,0-.28-.11-.24-.28l1.21-6c.03-.18-.07-.32-.24-.32h-2.85c-.14,0-.31.14-.35.32l-1.25,6c-.03.18-.17.28-.35.28h-3.06c-.17,0-.28-.11-.24-.28l1.25-6c.03-.18-.07-.32-.24-.32H.25c-.17,0-.28-.11-.24-.28l.52-2.58c.03-.18.21-.28.35-.28h2.71c.14,0,.31-.14.35-.32l.8-3.81c.03-.18-.07-.32-.24-.32H1.78c-.14,0-.28-.11-.24-.28l.56-2.58c0-.18.17-.28.35-.28h2.71c.17,0,.31-.14.35-.32L6.74.28c.03-.14.21-.28.38-.28h3.02c.17,0,.28.14.24.28l-1.25,6.07c-.03.18.07.32.24.32h2.81c.17,0,.35-.14.38-.32L13.79.28c.03-.14.21-.28.38-.28h3.02c.17,0,.28.14.24.28l-1.21,6.07c-.04.18.07.32.24.32h2.67c.17,0,.28.11.24.28l-.52,2.58c-.03.18-.21.28-.35.28h-2.71ZM8.72,9.81c-.14,0-.31.14-.35.32l-.8,3.81c-.03.18.07.32.24.32h2.85c.14,0,.31-.14.35-.32l.76-3.81c.03-.18-.07-.32-.21-.32h-2.85Z"/>
                </svg>
                <span>私の好きなシーン</span>
              </li>
              <li>
                <svg viewBox="0 0 19.38 24">
                  <path d="M15.8,9.81c-.17,0-.31.14-.35.32l-.8,3.81c-.03.18.07.32.24.32h2.71c.17,0,.28.11.24.28l-.52,2.58c-.04.18-.21.28-.38.28h-2.71c-.14,0-.31.14-.35.32l-1.21,6c-.03.18-.21.28-.38.28h-3.02c-.17,0-.28-.11-.24-.28l1.21-6c.03-.18-.07-.32-.24-.32h-2.85c-.14,0-.31.14-.35.32l-1.25,6c-.03.18-.17.28-.35.28h-3.06c-.17,0-.28-.11-.24-.28l1.25-6c.03-.18-.07-.32-.24-.32H.25c-.17,0-.28-.11-.24-.28l.52-2.58c.03-.18.21-.28.35-.28h2.71c.14,0,.31-.14.35-.32l.8-3.81c.03-.18-.07-.32-.24-.32H1.78c-.14,0-.28-.11-.24-.28l.56-2.58c0-.18.17-.28.35-.28h2.71c.17,0,.31-.14.35-.32L6.74.28c.03-.14.21-.28.38-.28h3.02c.17,0,.28.14.24.28l-1.25,6.07c-.03.18.07.32.24.32h2.81c.17,0,.35-.14.38-.32L13.79.28c.03-.14.21-.28.38-.28h3.02c.17,0,.28.14.24.28l-1.21,6.07c-.04.18.07.32.24.32h2.67c.17,0,.28.11.24.28l-.52,2.58c-.03.18-.21.28-.35.28h-2.71ZM8.72,9.81c-.14,0-.31.14-.35.32l-.8,3.81c-.03.18.07.32.24.32h2.85c.14,0,.31-.14.35-.32l.76-3.81c.03-.18-.07-.32-.21-.32h-2.85Z"/>
                </svg>
                <span>季節</span>
              </li>
              <li>
                <svg viewBox="0 0 19.38 24">
                  <path d="M15.8,9.81c-.17,0-.31.14-.35.32l-.8,3.81c-.03.18.07.32.24.32h2.71c.17,0,.28.11.24.28l-.52,2.58c-.04.18-.21.28-.38.28h-2.71c-.14,0-.31.14-.35.32l-1.21,6c-.03.18-.21.28-.38.28h-3.02c-.17,0-.28-.11-.24-.28l1.21-6c.03-.18-.07-.32-.24-.32h-2.85c-.14,0-.31.14-.35.32l-1.25,6c-.03.18-.17.28-.35.28h-3.06c-.17,0-.28-.11-.24-.28l1.25-6c.03-.18-.07-.32-.24-.32H.25c-.17,0-.28-.11-.24-.28l.52-2.58c.03-.18.21-.28.35-.28h2.71c.14,0,.31-.14.35-.32l.8-3.81c.03-.18-.07-.32-.24-.32H1.78c-.14,0-.28-.11-.24-.28l.56-2.58c0-.18.17-.28.35-.28h2.71c.17,0,.31-.14.35-.32L6.74.28c.03-.14.21-.28.38-.28h3.02c.17,0,.28.14.24.28l-1.25,6.07c-.03.18.07.32.24.32h2.81c.17,0,.35-.14.38-.32L13.79.28c.03-.14.21-.28.38-.28h3.02c.17,0,.28.14.24.28l-1.21,6.07c-.04.18.07.32.24.32h2.67c.17,0,.28.11.24.28l-.52,2.58c-.03.18-.21.28-.35.28h-2.71ZM8.72,9.81c-.14,0-.31.14-.35.32l-.8,3.81c-.03.18.07.32.24.32h2.85c.14,0,.31-.14.35-.32l.76-3.81c.03-.18-.07-.32-.21-.32h-2.85Z"/>
                </svg>
                <span>思い出</span>
              </li>
            </ul>
          </div>
          <div class="topmyfavoritethings__content">
            <p>毎日の暮らしのなかで見つけた、<wbr>とっておきの瞬間を<br>住民のみなさんから<wbr>投稿された写真でご紹介します。</p>
          </div>
          <div class="topmyfavoritethings__listimg">
            <div class="topmyfavoritethings__listimg__item">
              <img src="@/assets/img/myfavoritethings/topmyfavoritethings_feature_img_1.jpg" alt="myfavoritethings img 1" />
            </div>
            <div class="topmyfavoritethings__listimg__item">
              <img src="@/assets/img/myfavoritethings/topmyfavoritethings_feature_img_2.jpg" alt="myfavoritethings img 2" />
            </div>
            <div class="topmyfavoritethings__listimg__item">
              <img src="@/assets/img/myfavoritethings/topmyfavoritethings_feature_img_3.jpg" alt="myfavoritethings img 3" />
            </div>
            <div class="topmyfavoritethings__listimg__item">
              <img src="@/assets/img/myfavoritethings/topmyfavoritethings_feature_img_4.jpg" alt="myfavoritethings img 4" />
            </div>
          </div>
          <div class="topmyfavoritethings__link">
            <router-link class="btn_link" to="/myfavoritethings">MY FAVORITE THINGS トップへ</router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="topshopguide wave">
      <div class="container wow fadeInUp" v-if="shopGuideList.length != 0">
        <h2>SHOP GUIDE<span>ショップガイド</span></h2>
        <div class="topshopguide__list">
          <ItemShopguide :isLoadingChild="isLoading" :itemShopguideChild="item" :index="index" v-for="(item, index) in shopGuideList" :key="index"/>
        </div>
        <div class="topshopguide__link">
          <router-link class="btn_link" to="/shop-guide">もっと見る</router-link>
        </div>
      </div>
      <div class="container wow fadeInUp" v-else>
        <h2>SHOP GUIDE<span>ショップガイド</span></h2>
        <div class="no-data">
          <div class="text-notification">現在、ご案内する情報はありません</div>
        </div>
      </div>
    </div>

    <div class="topshopnew wave">
      <div class="container wow fadeInUp" v-if="shopNewsList.length != 0">
        <h2>SHOP NEWS<span>ショップニュース</span></h2>
        <div class="topshopnew__list">
          <ItemShopnews :isLoadingChild="isLoading" :itemShopnewsChild="item" :index="index" v-for="(item, index) in shopNewsList" :key="index"/>
        </div>
        <div class="topshopnew__link">
          <router-link class="btn_link" to="/shop-news">もっと見る</router-link>
        </div>
      </div>
      <div class="container wow fadeInUp" v-else>
        <h2>SHOP NEWS<span>ショップニュース</span></h2>
        <div class="no-data">
          <div class="text-notification">現在、ご案内する情報はありません</div>
        </div>
      </div>
    </div>

    <!-- <div class="img__banner banner1 wave">
      <div class="img__banner__holder pc">
        <img src="@/assets/img/top/bg-1.png" alt="" />
      </div>
      <div class="img__banner__holder sp">
        <img src="@/assets/img/top/sp/bg-1.png" alt="" />
      </div>
      <canvas id="waveCanvasBanner"></canvas>
    </div> -->

    <div class="topabout">
      <div class="container wow fadeInUp">
        <h2>ABOUT<span>HARUMI FLAGについて</span></h2>
        <div class="topabout__list">
          <div class="topabout__list__left">
            <div class="topabout__list__left__content">
              <img src="@/assets/img/top/img-about-flag.png" alt="" />
              <router-link to="/about/concept">
                HARUMI FLAGとは<br />晴海五丁目西地区第一種市街地再開発事業によって誕生する都市開発プロジェクト「HARUMI
                FLAG」の全体概要と街づくりのコンセプトを紹介します。
              </router-link>
              <!-- <router-link class="btn_link" to="/concept">もっと見る</router-link> -->
            </div>
          </div>
          <div class="topabout__list__right">
            <ItemAbout :itemAboutChild="item" :index="index" v-for="(item, index) in listItemAbout" :key="index"/>
          </div>
        </div>
        <div class="topaccess wow fadeInUp">
          <router-link to="/access">
            <div class="topaccess__holder">
              <div class="topaccess__left">
                <span class="topaccess__title"><img src="@/assets/img/top/access_icon.svg" alt="" /><span
                    class="harumi-font">ACCESS</span><span class="topaccess__note">アクセス</span></span>
                <span class="topaccess__content">東京BRT、電車、バス、コミュニティサイクル<br />行き先に合わせて自由自在。</span>
              </div>
              <div class="topaccess__right">
                <div class="topaccess__list">
                  <div class="topaccess__list__item">
                    <img src="@/assets/img/top/icon-access-01.png" alt="transport bus" />
                  </div>
                  <div class="topaccess__list__item">
                    <img src="@/assets/img/top/icon-access-02.png" alt="transport bike" />
                  </div>
                  <div class="topaccess__list__item">
                    <img src="@/assets/img/top/icon-access-03.png" alt="transport train" />
                  </div>
                </div>
              </div>
            </div>
          </router-link>
          <!-- <div class="bg-item">
            <router-link to="/coming-soon">
              <span>Coming Soon 準備中</span>
            </router-link>
          </div> -->
        </div>
      </div>
    </div>

    <div class="portal">
      <ItemPortal />
    </div>

    <div class="topenergy wave">
      <div class="container wow fadeInUp">
        <h2>ENVIRONMENT<span>環境</span></h2>
        <p class="txt__title">街全体で、エネルギーを効率よくマネジメント</p>
        <p class="txt__content">
          HARUMI
          FLAGは住宅だけではなく、商業施設などと連携し、街全体でエネルギーを効率的に利用することを目指しています。<br />
          エリアネットワークを介して各街区のエネルギー情報を集約し、街全体のエネルギーを見える化。<br />
          最適なエネルギーの活用を目指します。
        </p>
        <div class="topenergy__list">
          <div class="topenergy__list__item">
            <router-link to="/energy">
              <span class="item__number harumi-font">1</span>
              <span class="item__text">エネルギーマネジメント</span>
            </router-link>
            <!-- <div class="bg-item">
              <router-link to="/coming-soon">
                <span>Coming Soon 準備中</span>
              </router-link>
            </div> -->
          </div>
          <div class="topenergy__list__item">
            <router-link to="/energy-usage">
              <span class="item__number harumi-font">2</span>
              <span class="item__text">エネルギーの利用状況</span>
            </router-link>
            <!-- <div class="bg-item">
              <router-link to="/coming-soon">
                <span>Coming Soon 準備中</span>
              </router-link>
            </div> -->
          </div>
          <div class="topenergy__list__item">
            <router-link to="/environment">
              <span class="item__number harumi-font">3</span>
              <span class="item__text">環境への配慮</span>
            </router-link>
            <!-- <div class="bg-item">
              <router-link to="/coming-soon">
                <span>Coming Soon 準備中</span>
              </router-link>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="img__banner banner2">
      <div class="img__banner__holder">
        <img src="@/assets/img/top/bg-2.png" alt="" />
      </div>
    </div> -->
  </main>
</template>

<script>
  import CONSTANT from "../../constant";
  import { sliderSite } from "@/assets/js/home";
  import InfomationNewsList from "@/components/common/InfomationNewsList.vue";
  import ItemEvent from "@/components/common/ItemEvent.vue";
  import ItemShopguide from "@/components/common/ItemShopguide.vue";
  import ItemShopnews from "@/components/common/ItemShopnews.vue";
  import SliderSmall from "@/components/common/SliderSmall.vue";
  import SliderBig from "@/components/common/SliderBig.vue";
  import ItemAbout from "@/components/common/ItemAbout.vue";
  import ItemPortal from "@/components/common/ItemPortal.vue";
  import { wave } from "@/assets/js/wave";
  //Import
  import axios from "axios";
  import moment from "moment";
  import parser from 'xmltojson';
  import { getUrl, metaData } from '@/utils/helper';

  export default {
    name: "Home",
    components: {
      InfomationNewsList,
      ItemEvent,
      ItemShopguide,
      ItemShopnews,
      SliderSmall,
      SliderBig,
      ItemAbout,
      ItemPortal
    },
    data() {
      return {
        listSliderSmall: CONSTANT.dataSliderSmall,
        listItemAbout: CONSTANT.dataAboutRight,
        listFilter: CONSTANT.dataFilter[0],

        bigSliderList: [],
        inforNewsList: [],
        eventList: [],
        shopGuideList: [],
        shopNewsList: [],
        isLoading: true,
      };
    },
    mounted() {
      const listSlider = this.$el.querySelectorAll(".item__img");
      listSlider.forEach((element) => {
        element.style.backgroundImage = `url(${element.querySelector("img").src
          })`;
      });
    },
    computed: {
    currentDate() {
      return moment().date();
    },
    currentDay() {
      moment.locale('en');
      return moment().date("YYYY/MM/DD").format('dddd').substring(0,3);
    },
    currentMonth() {
      return moment().month()
    },
    curentYear() {
      return moment().year()
    }
  },
  methods: {
    bigSliderFunction: async function () {
      this.isLoading = true;
      try {
        const listSliderBig = await getUrl('/banner_top');
        var parsedobj = JSON.parse(JSON.stringify(listSliderBig))
        var filtered = this.$func.filterByDeliveryMedia(parsedobj.data, [this.listFilter.town,this.listFilter.all]);
        var sorted = this.$func.sortByNumberKey(filtered, 'display_order');
        return JSON.parse(JSON.stringify(sorted));
      } catch (e) {
          console.log(e)
      }
    },
    inforFunction: async function () {
      this.isLoading = true;
      try {
      const ListInfor = await getUrl('/information');
      var parsedobj = JSON.parse(JSON.stringify(ListInfor))
      var filtered = this.$func.filterByDeliveryMedia(parsedobj.data, [this.listFilter.town]);
      return JSON.parse(JSON.stringify(filtered));
      } catch (e) {
          console.log(e)
      }
    },
    //ItemEvent
    eventListFunction: async function () {
      this.isLoading = true;
      try {
        const ListEvent = await getUrl('/event');
        var parsedobj = JSON.parse(JSON.stringify(ListEvent))
        var filtered = this.$func.filterByDeliveryMedia(parsedobj.data, [this.listFilter.town]);
        return JSON.parse(JSON.stringify(filtered));
      } catch (e) {
          console.log(e)
      }
    },
     //ItemShopGuide
    shopGuideListFunction: async function () {
      this.isLoading = true;
      try {
        const listShopGuide = await getUrl('/shop_guide');
        var parsedobj = JSON.parse(JSON.stringify(listShopGuide.data))
        return JSON.parse(JSON.stringify(parsedobj));
      } catch (e) {
          console.log(e)
      }
    },
    //ItemShopNews 
    shopNewsListFunction: async function () {
      this.isLoading = true;
      try {
        const ListShopNews = await getUrl('/shop_news');
        var parsedobj = JSON.parse(JSON.stringify(ListShopNews))
        var filtered = this.$func.filterByDeliveryMedia(parsedobj.data, [this.listFilter.town]);
        return JSON.parse(JSON.stringify(filtered));
      } catch (e) {
          console.log(e)
      }
    },

    randomItem (items) {
        let currentIndex = items.length,  randomIndex;
        while (currentIndex > 0) {

        randomIndex = Math.floor(Math.random() * currentIndex); 
        currentIndex--;

        [items[currentIndex], items[randomIndex]] = [
          items[randomIndex], items[currentIndex]];
        }
        return items;
     },

    getGeneratePowerFunction: function () {
      // axios.get('/degitalsignage_day.xml', {
      axios.get('/LinkageData/service/XML/degitalsignage/DayEnergyInfo', {
        // headers: {
        //   Authorization: `Basic ${process.env.VUE_APP_BASE_TOKEN}`,
        // },
      }).then((response) => {
        const json = parser.parseString(response.data);
        const listDate = json.DayEnergyInfo[0].List_Date[0]._text.split(',');
        const posYesterday = listDate.length - 2;

        const listEneFarm = json.DayEnergyInfo[0].List_EneFarm_GeneratePower_Total[0]._text.split(',');
        const pvGenerate = json.DayEnergyInfo[0].PV_GeneratePower_Total[0]._text; 
        const pefcGenerate = json.DayEnergyInfo[0].PEFC_GeneratePower_Total[0]._text;
        
        this.listSliderSmall[0].slide_note = listEneFarm[posYesterday];
        this.listSliderSmall[1].slide_note = pvGenerate;
        this.listSliderSmall[2].slide_note = pefcGenerate;
      })
      .catch((error) => {
        console.log(error);
        this.listSliderSmall[0].slide_note = '';
        this.listSliderSmall[1].slide_note = '';
        this.listSliderSmall[2].slide_note = '';
      })
      .finally(() => {});
    },
  },
  created() {
    this.getGeneratePowerFunction();

    metaData(
      `HARUMIFLAGタウンポータル`,
      '中央区晴海。都心から驚くほど近い、広大な街区からはじまる、まったく新しい都市生活。HARUMIFLAGのタウンポータルサイトです。',
      'HARUMIFLAGタウンポータル',
      'website',
    )
    
    Promise.all([this.bigSliderFunction(), this.inforFunction(), this.eventListFunction(), this.shopGuideListFunction(), this.shopNewsListFunction()])
    .then((results) => {
      this.bigSliderList = results[0];
      this.inforNewsList = results[1];
      this.eventList = results[2];
      this.shopGuideList = this.randomItem(results[3]);
      this.shopNewsList = results[4];
      this.isLoading = false
    }).catch((error) => {
      console.log(error);
    })
  },

  updated() {
    sliderSite();
    wave();
  }
  };
</script>